import { useEffect, useState } from "react";
import ProjectHistory from "../ProjectHistory";
import { AnimatePresence, motion } from "framer-motion";

const Project = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyDatabseId, setHistoryDatabseId] = useState("");

  // get children
  useEffect(() => {
    async function fetchChildren() {
      const res = await fetch(
        "https://time-api.web-hub.online/api/page-children?page_id=" + item.id
      );

      const data = await res.json();
      const historyDatabaseId = data.children?.filter(
        (item) => item.type === "child_database"
      )?.[0]?.id;

      setHistoryDatabseId(historyDatabaseId);
    }

    fetchChildren();
  }, []);

  return (
    <>
      <div className="grid grid-cols-3 bg-white items-center rounded-3xl py-4 px-7 shadow-md">
        <div className="font-bold text-lg">
          {item?.properties?.available_time?.rich_text[0].plain_text}
        </div>
        <div className="font-bold text-lg">
          {item?.properties?.Time?.rich_text[0].plain_text}
        </div>
        <div>
          <button onClick={() => setIsOpen(!isOpen)} className="button-blue">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 5.66699V9.00033L11.0833 11.0837"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M2.615 4.72616L1.99 4.72866C1.99066 4.89341 2.05634 5.05124 2.17276 5.16781C2.28918 5.28439 2.44692 5.35028 2.61167 5.35116L2.615 4.72616ZM4.73333 5.36116C4.81541 5.36154 4.89676 5.34575 4.97273 5.3147C5.04871 5.28364 5.11782 5.23793 5.17613 5.18016C5.23444 5.1224 5.2808 5.05371 5.31256 4.97803C5.34432 4.90235 5.36087 4.82115 5.36125 4.73907C5.36163 4.657 5.34585 4.57565 5.31479 4.49968C5.28374 4.4237 5.23802 4.35459 5.18025 4.29628C5.12249 4.23797 5.0538 4.19161 4.97812 4.15985C4.90244 4.12809 4.82124 4.11154 4.73917 4.11116L4.73333 5.36116ZM3.22917 2.60116C3.22828 2.4354 3.16159 2.27678 3.04375 2.16019C2.92592 2.04361 2.76659 1.97861 2.60083 1.97949C2.43507 1.98038 2.27645 2.04707 2.15987 2.16491C2.04328 2.28274 1.97828 2.44206 1.97917 2.60782L3.22917 2.60116ZM2.125 9.00032C2.125 8.83456 2.05915 8.67559 1.94194 8.55838C1.82473 8.44117 1.66576 8.37532 1.5 8.37532C1.33424 8.37532 1.17527 8.44117 1.05806 8.55838C0.940848 8.67559 0.875 8.83456 0.875 9.00032H2.125ZM13.0625 16.0378C13.1366 15.9984 13.2019 15.9444 13.2547 15.8792C13.3074 15.814 13.3465 15.7388 13.3696 15.6581C13.3927 15.5775 13.3993 15.493 13.389 15.4097C13.3788 15.3265 13.3519 15.2461 13.3099 15.1735C13.2679 15.1008 13.2117 15.0374 13.1447 14.9869C13.0777 14.9364 13.0012 14.9 12.9198 14.8797C12.8384 14.8594 12.7537 14.8557 12.6709 14.8689C12.588 14.882 12.5086 14.9117 12.4375 14.9562L13.0625 16.0378ZM14.9558 12.4378C14.9114 12.509 14.8817 12.5883 14.8686 12.6712C14.8554 12.7541 14.8591 12.8387 14.8794 12.9201C14.8997 13.0015 14.9361 13.078 14.9866 13.1451C15.0371 13.2121 15.1005 13.2682 15.1732 13.3102C15.2458 13.3522 15.3261 13.3791 15.4094 13.3894C15.4927 13.3996 15.5772 13.393 15.6578 13.3699C15.7385 13.3468 15.8137 13.3078 15.8789 13.255C15.9441 13.2022 15.9981 13.1369 16.0375 13.0628L14.9558 12.4378ZM3.28333 3.22532C3.16553 3.34202 3.09891 3.50073 3.09813 3.66654C3.09735 3.83236 3.16247 3.99169 3.27917 4.10949C3.39586 4.22729 3.55457 4.29391 3.72039 4.29469C3.8862 4.29547 4.04553 4.23035 4.16333 4.11366L3.28333 3.22532ZM14.7183 3.28116C11.535 0.0978246 6.39083 0.0661576 3.22833 3.22866L4.11167 4.11116C6.77833 1.44532 11.1308 1.46116 13.835 4.16532L14.7183 3.28116ZM3.22833 3.22866L2.17333 4.28366L3.05667 5.16699L4.1125 4.11282L3.22833 3.22866ZM2.61167 5.35116L4.73333 5.36116L4.73917 4.11116L2.61833 4.10116L2.61167 5.35116ZM3.24 4.72282L3.22917 2.60116L1.97917 2.60782L1.99 4.72866L3.24 4.72282ZM9 2.12532C10.8234 2.12532 12.572 2.84965 13.8614 4.13897C15.1507 5.42828 15.875 7.17696 15.875 9.00032H17.125C17.125 6.84544 16.269 4.77882 14.7452 3.25508C13.2215 1.73135 11.1549 0.875324 9 0.875324V2.12532ZM9 15.8753C7.17664 15.8753 5.42795 15.151 4.13864 13.8617C2.84933 12.5724 2.125 10.8237 2.125 9.00032H0.875C0.875 11.1552 1.73102 13.2218 3.25476 14.7456C4.77849 16.2693 6.84512 17.1253 9 17.1253V15.8753ZM12.4375 14.9562C11.3929 15.5607 10.2069 15.8779 9 15.8753V17.1253C10.4792 17.1253 11.8667 16.7295 13.0625 16.0378L12.4375 14.9562ZM15.875 9.00032C15.8776 10.2072 15.5604 11.3933 14.9558 12.4378L16.0375 13.0628C16.7521 11.8283 17.1273 10.4267 17.125 9.00032H15.875ZM4.16333 4.11366C5.44904 2.83704 7.18815 2.12263 9 2.12532V0.875324C6.85862 0.872475 4.80323 1.71687 3.28333 3.22532L4.16333 4.11366Z"
                fill="white"
              />
            </svg>
            <span>Open History</span>
          </button>
        </div>
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              key="panel"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="col-span-3 overflow-hidden"
            >
              <ProjectHistory
                setHistory={setHistory}
                history={history}
                historyDatabseId={historyDatabseId}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default Project;
